var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon24PxInviteUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "4-icon-24-px-invite-user"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    className: "\\xF0\\x9F\\x8E\\xA8 Color"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5a4 4 0 012.906 6.75c.242.133.473.284.693.449a4.993 4.993 0 00-1.998 1.134 3.98 3.98 0 00-1.401-.328L12 13a4 4 0 00-3.98 3.603l-.017.227.054.054c.122.111.305.237.54.362l.147.074c.869.42 2.077.68 3.256.68h.1c.146.72.447 1.383.866 1.954-.32.03-.643.046-.966.046-3 0-6-1.343-6-3 0-2.26 1.25-4.228 3.095-5.251A4 4 0 0112 5zm0 2a2 2 0 100 4 2 2 0 000-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13.5a1 1 0 011 1V16h1.5a1 1 0 110 2H18v1.5a1 1 0 11-2 0V18h-1.5a1 1 0 110-2H16v-1.5a1 1 0 011-1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon24PxInviteUser);
export default __webpack_public_path__ + "static/media/4-icon-24-px-invite-user.c5641d92.svg";
export { ForwardRef as ReactComponent };